// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"89a4cebd","57":"f0686f0d","121":"8d1c31bd","787":"09e7e79f","896":"cb0951c4"}[chunkId] + ".chunk.js";
};